<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
        >
          <b-form-group
            label="Başlık"
            label-for="title"
          >
            <b-form-input
              id="title"
              v-model="itemData.title"
              placeholder="Başlık"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
        >
          <project-videos />
        </b-col>
        <b-col
          cols="12"
        >
          <b-form-group
            label="Video Bağlantısı"
            label-for="video_url"
          >
            <b-form-input
              id="video_url"
              v-model="videoUrl"
              placeholder="Video Bağlantısı"
              @input="getEmbedCode"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          class="text-center"
        >
          <b-embed
            v-if="itemData.video_embed"
            type="iframe"
            aspect="16by9"
            :src="youtubeUrl + itemData.video_embed"
          />
          <div
            v-else
            class="bg-light py-5 rounded text-muted"
          >
            <div class="my-2">
              <div>
                <FeatherIcon icon="VideoIcon" />
              </div>
              <div>
                Video Önizleme
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col
        cols="12"
      />
    </b-row>
    <b-button
      variant="primary"
      :disabled="!itemData.video_embed || itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
import {
  BCard, BCol, BFormGroup, BFormInput, BRow, BButton, BEmbed,
} from 'bootstrap-vue'
import ProjectVideos from '@/views/Admin/ProjectsVideoGallery/elements/Projects.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BEmbed,
    ProjectVideos,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      imageUrl: this.$store.state.app.baseURL,
      videoUrl: null,
      youtubeUrl: 'https://www.youtube.com/embed/',
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['projects_video_gallery/dataItem']
    },
  },
  methods: {
    getEmbedCode() {
      this.$store.dispatch('projects_video_gallery/getEmbedCode', this.videoUrl)
        .then(res => {
          this.itemData.video_embed = res.id
        })
    },
  },
}
</script>
